module.exports = __webpack_public_path__ + "static/media/A7S01638.d93b4155.jpg";